<template>
  <view
    class="loading_box b-flex b-align-centenr b-justify-center"
    v-show="is_loading"
    @touchmove.stop.prevent="moveHandle"
  >
    <view class="loadingview b-flex-column b-flex b-align-centenr b-justify-center">
      <image
        src="https://image.ceekee.com/app/loading/loading1.gif"
        v-if="!$store.getters['common/agentPlatId']"
      ></image>
      <image src="https://ceekeeimage-sh.oss-cn-shanghai.aliyuncs.com/tmc/gdcts/loading.gif" v-else></image>
      <text>{{ loading_text }}</text>
    </view>
  </view>
</template>

<script>
export default {
  data() {
    return {
      lastPage: '',
    };
  },
  methods: {
    switch_loading() {
      this.$store.commit('switch_loading');
    },
    moveHandle() {},
  },
  computed: {
    is_loading() {
      let currentPages = getCurrentPages();
      let currentRoute = null;
      if (currentPages.length > 0) {
        currentRoute = currentPages[currentPages.length - 1].route;
      }
      if (this.lastPage != currentRoute) {
        setTimeout(() => {
          this.lastPage = currentRoute;
          return this.$store.state.loading;
        }, 300);
      } else {
        return this.$store.state.loading;
      }
    },
    loading_text() {
      return this.$store.state.loadingtext;
    },
  },
};
</script>

<style scoped>
.loading_box {
  width: 100%;
  height: 100vh;
  /* background-color: rgba(0,0,0,0.6); */
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10000;
}
.loadingview {
  color: #222;
  background-color: rgba(232, 233, 234, 1);
  border-radius: 20rpx;
  padding: 0 20rpx 20rpx;
}
.loadingview image {
  width: 140rpx;
  height: 140rpx;
}
.loadingview text {
  color: #1182f9;
  font-size: 26rpx;
  position: relative;
  margin-top: -10rpx;
}
.loadingview .icon {
  width: 160rpx;
  height: 160rpx;
}
.iconfont {
  font-size: 60rpx;
  display: inline-block;
}
</style>
